module.exports = __webpack_public_path__ + "static/media/image-3.49b1d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-3.png
// module id = 2199
// module chunks = 0